/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type AdminNewsListItemNewsForPlannerFragment = { id: string, title: string, body: string, publishedAt: TimeString };

export const AdminNewsListItemNewsForPlannerFragmentDoc = gql`
    fragment AdminNewsListItemNewsForPlanner on NewsForPlanner {
  id
  title
  body
  publishedAt
}
    `;